<script setup lang="ts">
import Menu from '@/widgets/menu/index';
import CrossRoundIcon from '@/shared/ui/Icons/CrossRounded.vue';

defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { t } = useI18n();
</script>

<template>
  <teleport to="#teleports">
    <transition name="fade">
      <div v-if="modelValue" class="mobile-menu">
        <button
          class="mobile-menu__close"
          :aria-label="t('closeMenu')"
          @click="emit('update:modelValue', false)"
        >
          <cross-round-icon />
        </button>
        <Menu />
      </div>
    </transition>
  </teleport>
</template>

<style lang="less" scoped>
.mobile-menu {
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  min-height: 100dvh;
  background-color: white;
  z-index: 1001;
  padding: 60px @size-x5;

  &__close {
    position: absolute;
    top: @size-x4;
    right: @size-x4;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }
}
</style>
